<template>
    <div class="flex flex-col h-screen">

        <!-- Header -->
        <div class="p-3 bg-gray-300 border-b border-gray-400" v-if="!showingQuiz">
            <div class="m-auto max-w-3xl flex flex-col sm:flex-row sm:justify-between">
                <div class="flex items-center">
                    <img class="w-20 h-20 rounded border border-gray-400 shadow-md mr-3" :src="user.avatar" :alt="user.full_name">
                    <div>
                        <div class="font-semibold text-lg text-gray-900" v-text="user.full_name"></div>
                        <div class="text-sm text-gray-700 font-semibold">
                            {{ __('Email') }}: <span class="font-normal" v-text="user.email"></span>
                        </div>
                        <div class="text-sm text-gray-700 font-semibold">
                            {{ __('Student Number') }}: <span class="font-normal" v-text="user.id"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Quiz Name -->
        <div class="flex items-center bg-blue-400 py-3 shadow-md h-16" :class="{'fixed top-0 w-full' : showingQuiz}">
            <div class="w-full max-w-3xl mx-auto px-3 md:px-0 flex items-center justify-between">
                <div class="uppercase font-semibold text-white tracking-wide" v-text="quiz.title"></div>
                <button
                    v-if="showingQuiz"
                    @click="signOut()"
                    class="bg-red-600 border border-red-700 text-white font-bold tracking-wider uppercase px-2 py-1 rounded">
                    {{ __('Exit') }}
                </button>
            </div>
        </div>

        <div class="flex-1 pt-4">

            <!-- Quiz Questions -->
            <quiz-app-questions-form class="mt-16"
                                     v-if="showingQuiz"
                                     :questions="questions"
                                     :passing-score="quiz.min_passing_score"
                                     :score="score">
            </quiz-app-questions-form>

            <!-- Star or Exit Quiz -->
            <div v-else
                 class="max-w-3xl m-auto px-3 md:px-0">

                <div class="mb-3" v-if="quiz.description" v-html="quiz.description"></div>

                <div class="flex justify-between sm:flex-row flex-col">
                    <button
                        @click="showingQuiz = true"
                        class="mb-4 sm:mb-0 sm:w-none rounded bg-green-600 px-3 py-2 text-white font-semibold uppercase">
                        {{ __('Start Questionnaire') }}
                    </button>
                    <button
                        @click="signOut()"
                        class="sm:w-none rounded bg-red-600 px-3 py-2 text-white font-semibold uppercase">
                        {{ __('Exit') }}
                    </button>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true,
            }
        },

        data(){
            return {
                showingQuiz: false,
                user: this.value.user,
                quiz: this.value.quiz,
                score: this.value.score,
                questions: this.value.questions,
            }
        },

        created(){
            App.bus.$on('quiz-app-home', () => this.showingQuiz = false);
        },

        methods:{
            signOut(){
                Storage.forget('cet-quiz-app');
                this.$emit('input', null)
            },
        },
    }
</script>
